document.querySelectorAll('.quick-add__submit').forEach(button => {
  button.addEventListener('click', () => {
    const interval = setInterval(() => {
      const selects = document.querySelectorAll('select[id*="Option-quickadd"]');

      if (selects.length > 0) {
        clearInterval(interval);
        clearTimeout(timeout);

        selects.forEach(select => {
          select.addEventListener('change', (e) => {
            setTimeout(() => {
              window.dispatchEvent(new Event('scroll'));
            },500)
          });
        });
      }
    }, 300);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 8000);
  });
});
